import React, { useState } from 'react'
import { Layout, Steps, Button } from 'antd'
import Exitwithoutfinishing from '../../pages/Events/Views/Exitwithoutfinishing'
import './styles/sidebar.scss'
import { classesEventStore } from 'state/classes/classesStore'
import { List } from '@phosphor-icons/react'

const { Sider } = Layout
const ClassesSidebar: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const { Step } = Steps
  const [isModalVisibleEvent, setModalVisibleEvent] = useState(false)
  const {
    classesData,
    stepCounter,
    setStepCounter,
  }: {
    classesData: any | null
    stepCounter: number
    setStepCounter: (state: number) => void
  } = classesEventStore(store => ({
    classesData: store.classesData,
    stepCounter: store.stepCounter,
    setStepCounter: store.setStepCounter,
  }))

  const steps = [
    {
      title: 'Step 1',
      description: (
        <div className="flex justify-between align-center">
          <b className="text-18 w-600">Details</b>
          <button
            className={`progress-bar-btn ${
              classesData && classesData.statuses.details
                ? 'active'
                : 'non-active disabled'
            }`}
            disabled={!classesData?.statuses.details}
            onClick={() => setStepCounter(0)}
          >
            {classesData && classesData.statuses.details ? 'Review' : 'Start'}
          </button>
        </div>
      ),
    },
    {
      title: 'Step 2',
      description: (
        <div className="flex justify-between align-center">
          <b className="text-18 w-600">Contacts</b>
          <button
            className={`progress-bar-btn ${
              classesData && classesData.statuses.contacts
                ? 'active'
                : 'non-active'
            } ${classesData && classesData.statuses.details ? '' : 'disabled'}`}
            disabled={!classesData?.statuses.details}
            onClick={() => setStepCounter(1)}
          >
            {classesData && classesData.statuses.contacts ? 'Review' : 'Start'}
          </button>
        </div>
      ),
    },
    {
      title: 'Step 3',
      description: (
        <div className="flex justify-between align-center">
          <b className="text-18 w-600">Days & Hours</b>
          <button
            className={`progress-bar-btn ${
              classesData && classesData.statuses.daysAndHours
                ? 'active'
                : 'non-active'
            } ${classesData && classesData.statuses.details ? '' : 'disabled'}`}
            disabled={!classesData?.statuses.details}
            onClick={() => setStepCounter(2)}
          >
            {classesData && classesData.statuses.daysAndHours
              ? 'Review'
              : 'Start'}
          </button>
        </div>
      ),
    },
    {
      title: 'Step 4',
      description: (
        <div className="flex justify-between align-center">
          <b className="text-18 w-600">Curriculum</b>
          <button
            className={`progress-bar-btn ${
              classesData && classesData.statuses.curriculum
                ? 'active'
                : 'non-active'
            } ${classesData && classesData.statuses.details ? '' : 'disabled'}`}
            disabled={!classesData?.statuses.details}
            onClick={() => setStepCounter(3)}
          >
            {classesData && classesData.statuses.curriculum ? 'Review' : 'Start'}
          </button>
        </div>
      ),
    },
    {
      title: 'Step 5',
      description: (
        <div className="flex justify-between align-center">
          <b className="text-18 w-600">Costs</b>
          <button
            className={`progress-bar-btn ${
              classesData && classesData.statuses.costs
                ? 'active'
                : 'non-active'
            } ${classesData && classesData.statuses.details ? '' : 'disabled'}`}
            disabled={!classesData?.statuses.details}
            onClick={() => setStepCounter(4)}
          >
            {classesData && classesData.statuses.costs ? 'Review' : 'Start'}
          </button>
        </div>
      ),
    },
    {
      title: 'Step 6',
      description: (
        <div className="flex justify-between align-center">
          <b className="text-18 w-600">Enrollments</b>
          <button
            className={`progress-bar-btn ${
              classesData && classesData.statuses.enrollments
                ? 'active'
                : 'non-active'
            } ${classesData && classesData.statuses.details ? '' : 'disabled'}`}
            disabled={!classesData?.statuses.details}
            onClick={() => setStepCounter(5)}
          >
            {classesData && classesData.statuses.enrollments ? 'Review' : 'Start'}
          </button>
        </div>
      ),
    },
    {
      title: 'Step 7',
      description: (
        <div className="flex justify-between align-center">
          <b className="text-18 w-600">Communication</b>
          <button
            className={`progress-bar-btn ${
              classesData && classesData.statuses.communication
                ? 'active'
                : 'non-active'
            } ${classesData && classesData.statuses.details ? '' : 'disabled'}`}
            disabled={!classesData?.statuses.details}
            onClick={() => setStepCounter(6)}
          >
            {classesData && classesData.statuses.communication ? 'Review' : 'Start'}
          </button>
        </div>
      ),
    },
    {
      title: 'Step 8',
      description: (
        <div className="flex justify-between align-center">
          <b className="text-18 w-600">Settings</b>
          <button
            className={`progress-bar-btn ${
              classesData && classesData.statuses.settings
                ? 'active'
                : 'non-active'
            } ${classesData && classesData.statuses.details ? '' : 'disabled'}`}
            disabled={!classesData?.statuses.details}
            onClick={() => setStepCounter(7)}
          >
            {classesData && classesData.statuses.settings ? 'Review' : 'Start'}
          </button>
        </div>
      ),
    },
    //   description: (
    //     <div className="flex justify-between align-center">
    //       <b className="text-18 w-600">Groups</b>
    //       <button
    //         className={`progress-bar-btn ${stepCounter >= 8 ? 'active' : 'non-active'
    //           } ${stepCounter >= 0 ? '' : 'disabled'}`}
    //         disabled={stepCounter < 0}
    //         onClick={() => setStepCounter(8)}
    //       >
    //         {stepCounter > 8 ? 'Review' : 'Start'}
    //       </button>
    //     </div>
    //   ),
    // },
  ]

  return (
    <div>
      <div
        className="event-list-icon"
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
      >
        <List size={30} color="#000" />
      </div>

      <Sider
        className={`side-bar create-event-side-bar  ${isSidebarOpen ? 'sidebar-open' : ''
          }`}
        width={'auto'}
        style={{ maxWidth: 'auto' }}
      >
        <div className="d-flex flex-column justify-between stepper-section-header pb-10">
          <div>
            <h2 className="mb-16 create-event-sidebar-heading">Create class</h2>
            <span className="mb-20 complete-all-steps">
              Complete all steps to create the class, you can also save it as a
              draft at any step.
            </span>
            <Steps direction="vertical" current={stepCounter}>
              {steps.map(item => (
                <Step
                  key={item.title}
                  className="stepper event-stepper event-step-bar"
                  title={item.title}
                  description={item.description}
                />
              ))}
            </Steps>
          </div>
          <div className="mt-30 save-progress-and-exit">
            <Button
              className="primary-transparent mb-30"
              style={{ width: '100%', height: '50px' }}
              onClick={() => {
                setModalVisibleEvent(true)
              }}
            >
              Save progress & exit
            </Button>
          </div>
        </div>
        {isModalVisibleEvent ? (
          <Exitwithoutfinishing
            isModalVisibleEvent={isModalVisibleEvent}
            setModalVisibleEvent={setModalVisibleEvent}
          />
        ) : (
          <></>
        )}
      </Sider>
    </div>
  )
}

export default ClassesSidebar
